import React from 'react';
import "./index.css";

function TeacherPage() {

    return(
        <> 
        <div className="intro">
            <img className="teacherimg" src={"https://cdn-icons-png.flaticon.com/128/1995/1995574.png"} alt="선생님사진"></img>
            &nbsp;&nbsp;Teacher Introduction & Teaching Style</div>
        <br/>
        <div className="intro-box1">
            <div className="explanation">
            <div className="big"><img className="questionmark" src="https://thumb.ac-illust.com/t/cf/cf9bb39c2931829a5681f635d8902b46_t.jpeg" alt="questionmark"/>선생님들, 어떤 분들이시죠?</div>
            <br/>교사 경력 20년 이상으로, 영어 교육 뿐만 아니라 학생들의 공부 태도나 습관 등 전반적인 것에 능통하십니다.  <br/>
            선생님께 배운 학생들은 <span style={{color:'red'}}>특목고(외고, 자사고) , 사립 중학교, 지망 1순위 일반고</span>에 다수 진학합니다.<br/>
            아무래도 선생님께 많은 정보를 얻고, 어릴 때부터 스스로 공부하는 방법을 배운 덕분이겠죠?<br/><br/>
            어린 친구들이라도 선생님에게 쉽게 마음을 열 수 있도록 지도해 주십니다.<br/>
            또한, 간단히 자소서나 면접을 도와주실 수 있을 정도로 교생 진학 경험이 많습니다.
            </div>
        </div>
    <br/>
        
    
    
        
        <div className="intro-box3">
        <div className="explanation">
        <div className="big"><img className="questionmark" src="https://thumb.ac-illust.com/t/cf/cf9bb39c2931829a5681f635d8902b46_t.jpeg" alt="questionmark"/>            
        초등학교 커리큘럼은 어떻게 되나요?</div>                
            <br/>
        초등학교 친구들은 4학년생부터 받습니다.<br/>
        초등학교 4,5학년은 <b>TOSEL</b>이라는 시험을 준비하고 있습니다.<br/>
        <b>파닉스</b>부터 공부해야 하는 친구들은 기본기부터 탄탄하게 알려주고 있어요.<br/>
        영어에 쉽게 다가가기 위해서 영어로 국어나 과학 등 <b>다른 과목을 배우는 방식</b>과 
        리딩/리스닝/스피킹/그래머 로 나누어 <b>영역별로 가르치는 수업방식</b>을 채택하고 있어요!<br/>
        이후 친구들이 잘하면 초4때 토셀베이직, 초6때 토셀주니어,  중2때 토셀하이주니어를 준비할 수 있습니다.
        <br/>친구들과 함께 목표를 잡고 공부하여 <br/>좋은 성적을 내고 있어요.
            
    </div>
    </div>
        <br/>
        <div className="intro-box7">
            <div className="explanation">
            <div className="big"><img className="questionmark" src="https://thumb.ac-illust.com/t/cf/cf9bb39c2931829a5681f635d8902b46_t.jpeg" alt="questionmark"/>            
            중학교 커리큘럼은 어떻게 되나요?
            </div><br/>
            현재 중1/중2 학생들은 현재 <b>외고/특목고 반</b>을 만들어 교육중에 있구요,<br/>
            중학생 영어 내신 평균은<b> 98점</b>입니다.<br/>
            중학생의 경우에 고등학교 모의고사도 미리 시켜<br/>
            <b>안정 1등급</b>이 나올 때까지 연습을 시키고 있어요<br/>
            매년 고양외고/동두천외고/김포외고 등의 <b>특목고</b>와 <br/>
            안산동산고/천안북일고/한민고 등의 <b>자사고</b>에 <br/>진학할 수 있도록 돕고 있습니다.<br/>
            일반고에 가는 경우에도 비평준지역인 김포에서 <br/>내신 190점을 넘겨
            <b>지망 1순위 고등학교</b>에 갈 수 있도록 <br/>내신 공부를 대비해 주고 있습니다.
            <span style={{color:'red'}}>책임감 있는 티칭 위주의 수업</span>을 지향하는 학원입니다!
            </div>
            
        </div><br/>
        <div className="intro-box2">
        <div className="explanation">
        <div className="big"><img className="questionmark" src="https://thumb.ac-illust.com/t/cf/cf9bb39c2931829a5681f635d8902b46_t.jpeg" alt="questionmark"/>            
        고등학교 커리큘럼은 어떻게 되나요?</div><br/>
        
        고등학생은 내신과 수능을 같이 준비해줍니다. <br/>
        우리학원 고등친구들 기말고사 평균은 <b>93점</b>입니다.<br/>
        전반적인 전과목 공부 습관을 다잡아 대학에 진학할 수 있도록 지도하고 있습니다.<br/>
            </div>
        </div><br/>
        <div className="intro-box4">
            <div className="explanation">
            <div className="big"><img className="questionmark" src="https://thumb.ac-illust.com/t/cf/cf9bb39c2931829a5681f635d8902b46_t.jpeg" alt="questionmark"/>                            
            어떤 식의 수업, 그리고 숙제가 주어지는지 궁금해요!</div><br/>
            
            어린 친구들의 경우에는 특히나 꾸준한 영어 공부가 중요한데요, <br/>
            따라서 <span style={{color:'red'}}>문장의 흐름을 파악하는 '독해노트', 독해의 기본이 되는 '문법 정리', 수준별 단어시험</span> 등 꾸준한 점검을 통한 실력 향상을 이루어 냅니다.<br/>
            이렇게 기초 장비를 탄탄하게 마련한 후 수능, 자격증 시험, 입시 시험, 학교 시험 등을 준비하는 훈련을 꾸준히 시켜 성과를 낼 수 있도록 돕습니다.
            <br/>
            </div>

        </div>
        
    <br/>
        </>
    );
}

export default TeacherPage;